import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'courseData',
    label: 'Course Data Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
